import moment from "moment";

function findDuration(d1) {
  if (!d1) return;
  return d1
    .replace("P", "")
    .replace("D", "d ")
    .replace("T", "")
    .replace("H", "h ")
    .replace("M", "m");
}

function getDateDifference(d1, d2) {
  //d1 > d2
  var a = moment(d1);
  var b = moment(d2);

  var min = a.diff(b, "minutes");
  var hr = a.diff(b, "hours");
  return hr + "hr " + (min - hr * 60) + "min";
}
function convertHM(value) {
  const sec = parseInt(value, 10); // convert value to number if it's string
  let hours = Math.floor(sec / 3600); // get hours
  let minutes = Math.floor((sec - hours * 3600) / 60); // get minutes
  let seconds = sec - hours * 3600 - minutes * 60; //  get seconds
  // add 0 if value < 10; Example: 2 => 02
  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  return hours + " hr " + minutes + " min"; // Return is HH : MM : SS
}

const TimeFormatting = (DateTimeValue) => {
  if (DateTimeValue == null || DateTimeValue == undefined) return null;
  return moment(DateTimeValue.split(".")[0]).format("HH:mm");
};
const momentToHrs = (date) => {
  if (date == "") date = new Date();
  let hours = date.getHours();
  let minutes = date.getMinutes();
  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  let datef = `${hours}:${minutes}`;
  return datef;
};
export {
  findDuration,
  getDateDifference,
  convertHM,
  momentToHrs,
  TimeFormatting,
};
